module.exports = __webpack_public_path__ + "assets/img/client-logo-playstation-mono.d0ae77c8.png";